import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/azimuth-thruster-labeled/azimuth-thruster-labeled.js';
      import {CommandStatus} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/badge-command/badge-command.js';
import {AzimuthThrusterLabeledSize} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/azimuth-thruster-labeled/azimuth-thruster-labeled.js';
import {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
import {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';
import {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';
import {PropellerType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/propeller.js';

      export interface Props {
     label?: string;
     commandStatus?: CommandStatus;
     size?: AzimuthThrusterLabeledSize;
     angle?: number;
     angleSetpoint?: number | undefined;
     newAngleSetpoint?: number | undefined;
     atAngleSetpoint?: boolean;
     angleSetpointAtZeroDeadband?: number;
     angleSetpointOverride?: boolean;
     autoAtAngleSetpoint?: boolean;
     autoAtAngleSetpointDeadband?: number;
     touching?: boolean;
     thrust?: number;
     thrustSetpoint?: number | undefined;
     atThrustSetpoint?: boolean;
     autoAtThrustSetpoint?: boolean;
     autoAtThrustSetpointDeadband?: number;
     thrustSetpointAtZeroDeadband?: number;
     thrustSetpointOverride?: boolean;
     angleAdvices?: AngleAdvice[];
     thrustAdvices?: LinearAdvice[];
     tickmarkStyle?: TickmarkStyle;
     singleDirection?: boolean;
     topPropeller?: PropellerType;
     bottomPropeller?: PropellerType
   }

      
  
      export type {CommandStatus} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/badge-command/badge-command.js';
export type {AzimuthThrusterLabeledSize} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/azimuth-thruster-labeled/azimuth-thruster-labeled.js';
export type {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
export type {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';
export type {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';
export type {PropellerType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/propeller.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAzimuthThrusterLabeled',
  props: {
    label: {},
    commandStatus: {},
    size: {},
    angle: {},
    angleSetpoint: {},
    newAngleSetpoint: {},
    atAngleSetpoint: { type: Boolean },
    angleSetpointAtZeroDeadband: {},
    angleSetpointOverride: { type: Boolean },
    autoAtAngleSetpoint: { type: Boolean },
    autoAtAngleSetpointDeadband: {},
    touching: { type: Boolean },
    thrust: {},
    thrustSetpoint: {},
    atThrustSetpoint: { type: Boolean },
    autoAtThrustSetpoint: { type: Boolean },
    autoAtThrustSetpointDeadband: {},
    thrustSetpointAtZeroDeadband: {},
    thrustSetpointOverride: { type: Boolean },
    angleAdvices: {},
    thrustAdvices: {},
    tickmarkStyle: {},
    singleDirection: { type: Boolean },
    topPropeller: {},
    bottomPropeller: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-azimuth-thruster-labeled',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})